// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#hellopreloader {
    display: flex;
  justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 3000000000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-width: 320px;
    background-color: #F5F6F7;
    box-sizing: border-box;
    opacity: 1;
    transition: opacity .5s ease;
  }
  
  #hellopreloader_preload {
    position: relative;
    width: 142px;
    height: 142px;
    border-radius: 28px;
    box-sizing: border-box;
  }
  
  #hellopreloader_logo {
    width: 128px;
    height: 128px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
  justify-content: center;
    align-items: center;
    border-radius: 24px;
    border: 2px solid #FFF;
    animation: background 1.5s cubic-bezier(0,-0.2,1,1.2) forwards;
    box-sizing: border-box;
  }
  
  #hellopreloader_logo-svg {
    animation: scale 1.5s cubic-bezier(0,-0.2,1,1.2) forwards;
    box-sizing: border-box;
  }
  
  #hellopreloader_loading-bar {
    width: 138px;
    height: 138px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
  }
  
  .border-svg {
    transform: rotate(-180deg);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  
  .border-static {
    stroke-width: 4px;
    stroke: #59A020;
    stroke-linejoin: round;
    stroke-linecap: bevel;
    box-sizing: border-box;
  }
  
  .border-filling {
    stroke-width: 5px;
    stroke: #ECECEC;
    stroke-linejoin: bevel;
    stroke-linecap: bevel;
    stroke-dasharray: 500;
    animation: lineMove 3s linear infinite both;
    box-sizing: border-box;
  }
  
  @keyframes scale {
      0% {
          transform: scale(0);
      }
      50% {
          transform: scale(1.2);
      }
      100% {
          transform: scale(1);
      }
  }
  
  @keyframes background {
      0% {
          background-color: #FFFFFF;
      }
      100% {
          background-color: #59A020;
      }
  }
  
  /* !!!! В Safari нельзя использовать отрицательные значения stroke-dashoffset */
  @keyframes lineMove {
    0% { 
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  
  @keyframes heart-beating {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.2);
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Loader.css"],"names":[],"mappings":"AAAA;IAGI,aAAa;EAGZ,uBAAuB;IAGlB,mBAAmB;IACzB,eAAe;IACf,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IAEjB,sBAAsB;IAC9B,UAAU;IAGF,4BAA4B;EACtC;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IAEX,sBAAsB;EAChC;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAGD,gCAAgC;IAGxC,aAAa;EAGZ,uBAAuB;IAGlB,mBAAmB;IACzB,mBAAmB;IACnB,sBAAsB;IAEd,8DAA8D;IAE9D,sBAAsB;EAChC;;EAEA;IAEU,yDAAyD;IAEzD,sBAAsB;EAChC;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAGD,gCAAgC;IAEhC,sBAAsB;EAChC;;EAEA;IAGU,0BAA0B;IAClC,WAAW;IACX,YAAY;IAEJ,sBAAsB;EAChC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IAEb,sBAAsB;EAChC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IAEb,2CAA2C;IAE3C,sBAAsB;EAChC;;EAiBA;MACI;UAEY,mBAAmB;MAC/B;MACA;UAEY,qBAAqB;MACjC;MACA;UAEY,mBAAmB;MAC/B;EACJ;;EAWA;MACI;UACI,yBAAyB;MAC7B;MACA;UACI,yBAAyB;MAC7B;EACJ;;EAEA,+EAA+E;EAS/E;IACE;MACE,uBAAuB;IACzB;IACA;MACE,oBAAoB;IACtB;EACF;;EAaA;IACE;MAEU,mBAAmB;IAC7B;IACA;MAEU,qBAAqB;IAC/B;EACF","sourcesContent":["#hellopreloader {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n       -ms-flex-pack: center;\r\n     justify-content: center;\r\n    -webkit-box-align: center;\r\n       -ms-flex-align: center;\r\n          align-items: center;\r\n    position: fixed;\r\n    z-index: 3000000000;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    min-width: 320px;\r\n    background-color: #F5F6F7;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    opacity: 1;\r\n    -webkit-transition: opacity .5s ease;\r\n         -o-transition: opacity .5s ease;\r\n            transition: opacity .5s ease;\r\n  }\r\n  \r\n  #hellopreloader_preload {\r\n    position: relative;\r\n    width: 142px;\r\n    height: 142px;\r\n    border-radius: 28px;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n  }\r\n  \r\n  #hellopreloader_logo {\r\n    width: 128px;\r\n    height: 128px;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n        -ms-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n       -ms-flex-pack: center;\r\n     justify-content: center;\r\n    -webkit-box-align: center;\r\n       -ms-flex-align: center;\r\n          align-items: center;\r\n    border-radius: 24px;\r\n    border: 2px solid #FFF;\r\n    -webkit-animation: background 1.5s cubic-bezier(0,-0.2,1,1.2) forwards;\r\n            animation: background 1.5s cubic-bezier(0,-0.2,1,1.2) forwards;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n  }\r\n  \r\n  #hellopreloader_logo-svg {\r\n    -webkit-animation: scale 1.5s cubic-bezier(0,-0.2,1,1.2) forwards;\r\n            animation: scale 1.5s cubic-bezier(0,-0.2,1,1.2) forwards;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n  }\r\n  \r\n  #hellopreloader_loading-bar {\r\n    width: 138px;\r\n    height: 138px;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n        -ms-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n  }\r\n  \r\n  .border-svg {\r\n    -webkit-transform: rotate(-180deg);\r\n        -ms-transform: rotate(-180deg);\r\n            transform: rotate(-180deg);\r\n    width: 100%;\r\n    height: 100%;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n  }\r\n  \r\n  .border-static {\r\n    stroke-width: 4px;\r\n    stroke: #59A020;\r\n    stroke-linejoin: round;\r\n    stroke-linecap: bevel;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n  }\r\n  \r\n  .border-filling {\r\n    stroke-width: 5px;\r\n    stroke: #ECECEC;\r\n    stroke-linejoin: bevel;\r\n    stroke-linecap: bevel;\r\n    stroke-dasharray: 500;\r\n    -webkit-animation: lineMove 3s linear infinite both;\r\n            animation: lineMove 3s linear infinite both;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n  }\r\n  \r\n  @-webkit-keyframes scale {\r\n      0% {\r\n          -webkit-transform: scale(0);\r\n                  transform: scale(0);\r\n      }\r\n      50% {\r\n          -webkit-transform: scale(1.2);\r\n                  transform: scale(1.2);\r\n      }\r\n      100% {\r\n          -webkit-transform: scale(1);\r\n                  transform: scale(1);\r\n      }\r\n  }\r\n  \r\n  @keyframes scale {\r\n      0% {\r\n          -webkit-transform: scale(0);\r\n                  transform: scale(0);\r\n      }\r\n      50% {\r\n          -webkit-transform: scale(1.2);\r\n                  transform: scale(1.2);\r\n      }\r\n      100% {\r\n          -webkit-transform: scale(1);\r\n                  transform: scale(1);\r\n      }\r\n  }\r\n  \r\n  @-webkit-keyframes background {\r\n      0% {\r\n          background-color: #FFFFFF;\r\n      }\r\n      100% {\r\n          background-color: #59A020;\r\n      }\r\n  }\r\n  \r\n  @keyframes background {\r\n      0% {\r\n          background-color: #FFFFFF;\r\n      }\r\n      100% {\r\n          background-color: #59A020;\r\n      }\r\n  }\r\n  \r\n  /* !!!! В Safari нельзя использовать отрицательные значения stroke-dashoffset */\r\n  @-webkit-keyframes lineMove {\r\n    0% { \r\n      stroke-dashoffset: 1000;\r\n    }\r\n    100% {\r\n      stroke-dashoffset: 0;\r\n    }\r\n  }\r\n  @keyframes lineMove {\r\n    0% { \r\n      stroke-dashoffset: 1000;\r\n    }\r\n    100% {\r\n      stroke-dashoffset: 0;\r\n    }\r\n  }\r\n  \r\n  @-webkit-keyframes heart-beating {\r\n    0% {\r\n      -webkit-transform: scale(1);\r\n              transform: scale(1);\r\n    }\r\n    100% {\r\n      -webkit-transform: scale(1.2);\r\n              transform: scale(1.2);\r\n    }\r\n  }\r\n  \r\n  @keyframes heart-beating {\r\n    0% {\r\n      -webkit-transform: scale(1);\r\n              transform: scale(1);\r\n    }\r\n    100% {\r\n      -webkit-transform: scale(1.2);\r\n              transform: scale(1.2);\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
